import './ExternalSystemAccountItem.css';

import React from "react";
import { IExternalSystemAccountItemProps } from './~types/ExternalSystemAccountItemProps';

function ExternalSystemAccountItem(props: IExternalSystemAccountItemProps) {
    return (
        <div className='external-system-account-container'>
            <iframe className='external-system-frame' src={props.account.externalSystemLink}/>
        </div>
    );
}

export default ExternalSystemAccountItem;
